module.exports = __webpack_public_path__ + "static/media/benefits-left-detail.16461295.gif";